// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Section Container */
.project-showcase {
    text-align: center;
    margin-top: 64px;
}

/* Section Title */
.project-header {
    margin-bottom: 20px;
}

.project-gray-text-style {
    font-size: 14px;
    font-weight: 700;
    color: #4A4A4A; /* Dark gray color */
    font-family: "Plus Jakarta Sans", sans-serif;
}

.heading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px; /* Adjust spacing between line and text */
    margin-bottom: 24px;
}

.green-line {
    width: 30px; /* Adjust width */
    height: 5px; /* Adjust thickness */
    background-color: #008D62; /* Green color */
    border-radius: 5px; /* Rounded edges */
}

.heading-text {
    font-size: 20px;
    font-weight: 600;
    color: #4A4A4A; /* Dark gray color */
    font-family: "Plus Jakarta Sans", sans-serif;
}

h2 {
    font-size: 24px;
    font-weight: bold;
    color: #212529;
}

/* Logo Container */
.project-logo-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

/* Logo Styling */
.project-logo {
    width: 120px;
    height: auto;
    max-width: 100%;
}

/* Responsive */
@media (max-width: 768px) {
    h2 {
        font-size: 20px;
    }

    .project-logo {
        width: 100px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home/Component/Projects/project.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAE,oBAAoB;IACpC,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS,EAAE,yCAAyC;IACpD,mBAAmB;AACvB;;AAEA;IACI,WAAW,EAAE,iBAAiB;IAC9B,WAAW,EAAE,qBAAqB;IAClC,yBAAyB,EAAE,gBAAgB;IAC3C,kBAAkB,EAAE,kBAAkB;AAC1C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAE,oBAAoB;IACpC,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA,eAAe;AACf;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":["/* Section Container */\n.project-showcase {\n    text-align: center;\n    margin-top: 64px;\n}\n\n/* Section Title */\n.project-header {\n    margin-bottom: 20px;\n}\n\n.project-gray-text-style {\n    font-size: 14px;\n    font-weight: 700;\n    color: #4A4A4A; /* Dark gray color */\n    font-family: \"Plus Jakarta Sans\", sans-serif;\n}\n\n.heading-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px; /* Adjust spacing between line and text */\n    margin-bottom: 24px;\n}\n\n.green-line {\n    width: 30px; /* Adjust width */\n    height: 5px; /* Adjust thickness */\n    background-color: #008D62; /* Green color */\n    border-radius: 5px; /* Rounded edges */\n}\n\n.heading-text {\n    font-size: 20px;\n    font-weight: 600;\n    color: #4A4A4A; /* Dark gray color */\n    font-family: \"Plus Jakarta Sans\", sans-serif;\n}\n\nh2 {\n    font-size: 24px;\n    font-weight: bold;\n    color: #212529;\n}\n\n/* Logo Container */\n.project-logo-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n}\n\n/* Logo Styling */\n.project-logo {\n    width: 120px;\n    height: auto;\n    max-width: 100%;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    h2 {\n        font-size: 20px;\n    }\n\n    .project-logo {\n        width: 100px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
